<template>
    <component v-if="dynamicComponent" :is="dynamicComponent" v-bind="$props" v-on="$listeners"/>
</template>

<script>
// review-component-renderer #hot-reload-debug
import ReviewComponent from "@components/review/review-component.vue";

export default {
    name: `review-component-renderer`,
    extends: ReviewComponent,
    computed: {
        dynamicComponent() {
            if (this.types.indexOf(this.component.type) === -1)
                return null;

            return () => import(`@/components/review/review-component-${this.component.type}.vue`);
        }
    },
    data() {
        return {
            types: [`text`, `image`, `button`]
        }
    }
}
</script>

<style scoped lang="scss">
</style>
